import { Box } from 'braid-design-system';

import * as styles from './TabSlider.css';

interface Props {
  offset: number;
  scale: number;
}

const TabSlider = ({ offset, scale }: Props) => (
  <Box
    className={styles.root}
    style={{
      transform: `translateX(${offset}px) scaleX(${scale})`,
    }}
  />
);

export default TabSlider;
